module.exports = __webpack_public_path__ + "img/HY3701-177.e2349a07.jpg";